var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{staticClass:"unique_cstm_tab"},[_c('vs-tab',{attrs:{"label":"SMS"}},[_c('SMS')],1),_c('vs-tab',{attrs:{"label":"SMS Log"}},[_c('SMSLOG')],1),(_vm.checkViewPermission())?_c('vs-tab',{attrs:{"label":"SMS Template"}},[_c('SMSTemplate')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }